
import * as Sentry from '@sentry/browser';
import version from 'consts:version';
import environmentName from 'consts:environment_name';

/*
 *  Inits Sentry if a configuration is available. In case
 *  loading fails we skip error tracking.
 */
// init :: (Events, ImdSettings) -> Promise
export function init (events, imdSettings) {
  const { sentry } = imdSettings.integration;
  if (sentry && sentry.dsn) {
    Sentry.init(
      Object.assign(
        {
          release: `ds@${version}`,
          environment: environmentName,
          // Disable tracing as it sets `sentry-trace` header and blocks preloading of resources
          // integrations: [new Integrations.BrowserTracing()], 
          tracesSampleRate: 1.0,

          beforeBreadcrumb (breadcrumb, _hint) {
            const { category } = breadcrumb;

            // Delete original navigation breadcrumbs. These won't capture correct change
            if (category == 'navigation') return null;

            // Fixed version
            if (category == 'x-navigation') breadcrumb.category = 'navigation';

            return breadcrumb;
          }
        },
        sentry
      )
    );

    return Promise.resolve();
  }
  else {
    return Promise.reject(`No Setry 'dsn' property`);
  }
}
